import { useApiGet } from '../../../api/api.hooks';
import { InternationalACHSetupDetails } from '../../../pages/Dividend/store/dividend.model';
import { APP_CONFIG } from '../../../config';

export function useInternationalACHSetupDetails(regionCode: string) {
  const url = APP_CONFIG.api.dividends.loadSetupDetails(regionCode);
  return useApiGet<InternationalACHSetupDetails[]>(url);
}
